<template>
  <material-card
    outlined
    class="fill-height notification-root v-card-dense without-padding"
  >
    <v-card-title>
      <SectionTitle 
        :title="$t('views.charts.notificationTable.title')"
        :subtitle="$t('views.charts.notificationTable.description')"/>

      <v-spacer />

      <v-text-field
        v-model="search"
        :label="$t('views.projects.search')"
        append-icon="$fas fa-search"
        single-line
        hide-details
      />
    </v-card-title>
    <v-data-table
      class="row-pointer fill-width"
      :headers="headers"
      sort-by="date"
      :sort-desc="true"
      :items="notifications"
      :items-per-page="-1"
      :search="search"
      hide-default-footer
      fixed-header
      style="overflow: auto"
      height="100%"
      @click:row="readNotification"
    >
      <template #item.risk="{ item: notification }">
        <RingChart
          :id="'icon' + notification.id"
          :inner-radius="14"
          :outer-radius="16"
          :percentile="100"
          :yellow-min="notification.risk == 3 ? 101 : 99"
          :green-min="120"
          :no-background-color="true"
          background-color="transparent"
          class="my-2 ring-small"
        >
          <v-icon class="color-text-secondary">$far fa-bell</v-icon>
        </RingChart>
      </template>
      <template #item.date="{ item: notification }">
        <div :class="{ unread: !notification.read }">
          {{ notification.date ? formatDate(notification.date) : '-' }}
        </div>
      </template>
      <template #item.text="{ item: notification }">
        <div :class="{ unread: !notification.read }">
          {{ notification.text }}
        </div>
        <div v-if="notification.solution">
          {{ notification.solution }}
        </div>
      </template>
      <template #item.read="{ item: notification }">
        <v-icon :color="notificationColor(notification)">
          {{ notificationIcon(notification) }}
        </v-icon>
      </template>
    </v-data-table>
  </material-card>
</template>
<script>
import SectionTitle from '@/components/core/SectionTitle.vue'
import RingChart from '../Ring.vue'
import { kpiTypes } from '@/utils/enum'
import { toMonthYearDay } from '@/utils/date'

export default {
  name: 'NotificationTable',
  components: {
    SectionTitle,
    RingChart,
  },
  props: {
    notifications: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      headers: [
        {
          text: this.$t('views.notifications.headers.risk'),
          value: 'risk',
          width: '80px',
        },
        {
          text: this.$t('views.notifications.headers.date'),
          value: 'date',
          width: '120px',
        },
        {
          text: this.$t('views.notifications.headers.description'),
          value: 'text',
          sortable: false,
        },
        {
          text: this.$t('views.notifications.headers.read'),
          value: 'read',
          align: 'center',
        },
      ],
      formatDate: toMonthYearDay,
      search: '',
    }
  },

  methods: {
    notificationColor(notification) {
      if (notification.read) {
        return 'gray'
      }
      return 'primary'
    },

    notificationIcon(notification) {
      if (notification.name === kpiTypes.RMEMO) {
        return '$fas fa-link'
      }
      if (notification.read) {
        return '$fas fa-envelope-open'
      }
      return '$fas fa-envelope'
    },

    readNotification(notification) {
      if (notification.name === kpiTypes.RMEMO) {
        const routeData = this.$router.resolve({
          path: '/dashboard/reports',
          query: { project: notification.project },
        })
        window.open(routeData.href, '_blank')
        notification.read = true
      } else if (
        !notification.read &&
        notification?.metadata?.product &&
        !notification.sticky
      ) {
        this.$store.dispatch('readProductionNotification', notification)
        notification.read = true
      } else if (!notification.read && !notification.sticky) {
        this.$store.dispatch('readNotification', notification.id)
        notification.read = true
      }
    },
  },
}
</script>
<style>
.row-pointer > .v-data-table__wrapper > table > tbody > tr :hover {
  cursor: pointer;
}
.unread {
  font-weight: bold;
}
</style>
